import type { User } from "@deft/shared";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

export interface RouterContext {
  auth: {
    user: User | null;
    loading: boolean;
    login: () => void;
    logout: () => void;
  };
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
});
